export class CloseMoveToExistingBusinessModalEvent {}
